var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUcs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ucs_svg__e29bfc67-2903-44e1-944a-ae4f7b2c12ba",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".ucs_svg__st0{fill:#dd042d}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ucs_svg__st0",
    d: "M106.7,0h-64C30.9,0,21.3,9.6,21.3,21.3h19.2v62c0.4,4.7,7.3,9.9,21.6,10.8c11.7,0.7,22.6-3.6,25.4-10.2V21.4 c2.4,0.2,16.1,3.8,18.7,17c0.2,0.8,0.3,1.6,0.4,2.3c0,0.7,0.1,1.2,0.1,1.9v64H87.5v-9.3c-3.2,4.5-8,7.8-13.3,9.3H42.7 c-11.6,0.1-21.2-9.2-21.3-20.8V21.3C9.6,21.3,0,30.9,0,42.7v64C0,118.4,9.6,128,21.3,128h64c11.8,0,21.3-9.6,21.3-21.3 c11.8,0,21.3-9.6,21.3-21.3v-64C128,9.6,118.4,0,106.7,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcs);
export default __webpack_public_path__ + "static/media/ucs.a86b8441c79237f8a7107ed0e5cc47ec.svg";
export { ForwardRef as ReactComponent };